import { useNavigate } from "react-router-dom";
import Modal from "../../../../../../components/portal/Modal";
import GrayButton from "../../../../../../components/UI/buttonUI/GrayButton";

export default function DiscardedSuccess({ cylinderSerialNo }) {
  const navigate = useNavigate(0);
  return (
    <Modal
      onClose={() => navigate(0)}
      modalWidth="max-w-md w-11/12 2xs:max-sm:w-95% 2xs:max-md:px-4 2xs:max-md:py-4 pb-8 pt-8 px-8"
    >
      <p className="text-center pb-3 text-red-700">
        Cylinder Serial No. - ({cylinderSerialNo}) has been Discarded !
      </p>
      <div className="pt-5 text-center">
        <GrayButton btnText="Ok" onClick={() => navigate(0)} />
      </div>
    </Modal>
  );
}
